<div class="template3 bonus-info">
    <div *ngIf="displayBonusInfoForm" [class.hideValidation]="validationMessageInitialHide">
        <json-schema-form [widgets]="customWidgets" [framework]="selectedFrameWork" [form]="jsonFormObject" [options]="jsonFormOptions" (onChanges)="onChanges($event)"
            (onSubmit)="saveBonusInfo($event)" (valueChanges)="changeInputValue($event)">
        </json-schema-form>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/enrollment/bonus-schema-info.component.html